import api from "@/axios";

export default {
  findAll() {
    return api().get("country");
  },
  findOne(id) {
    return api().get(`admin/country/${id}`);
  },
  create(data) {
    return api().post("admin/country/add", data);
  },
  update(id, data) {
    return api().patch(`admin/country/${id}`, data);
  },
  remove(id) {
    return api().delete(`country/${id}`);
  },
};
